exports.supportedLocales = ['en', 'de']
